// OPUS-1619 — the scene a profile's NLE definitions are read from.
//
// A profile listed here reads every NLE caption block from the named scene
// and nowhere else: not the scene the renderer runs, and not a caption the
// operator happened to use. A graphic or caption that scene lacks keeps the
// builder's data rather than falling back to another scene.
//
// A profile NOT listed reads from the renderer's own scene, as before.
//
// The name is the scene's name in scene-service, matched exactly, and the
// scene must belong to the operator's organisation.

export const NLE_SCENE_BY_PROFILE = {
  football_pls: 'PLS_2026_NLE',
};

export function getNleSceneName(profileId) {
  return (profileId && NLE_SCENE_BY_PROFILE[profileId]) || null;
}
